import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, Package, Truck, Home } from "lucide-react";

export default function OrderSuccess() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${orderId}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [orderId]);

  return (
    <div className="max-w-3xl mx-auto px-4 py-20 text-center" data-testid="order-success-page">
      <CheckCircle2 className="h-16 w-16 text-[#E65A28] mx-auto" />
      <h1 className="font-serif text-5xl text-[#0A192F] mt-6">Order confirmed!</h1>
      <p className="mt-3 text-[#666]">
        Thank you for shopping with Roop Anand. Your order <span className="font-semibold text-[#0A192F]" data-testid="order-id">{orderId}</span> has been placed.
      </p>

      {order && (
        <div className="mt-10 bg-white rounded-2xl p-6 text-left">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <p className="text-[#666] uppercase tracking-widest text-xs">Tracking ID</p>
              <p className="font-semibold text-[#0A192F] mt-1">{order.tracking_id}</p>
            </div>
            <div>
              <p className="text-[#666] uppercase tracking-widest text-xs">Total</p>
              <p className="font-semibold text-[#0A192F] mt-1">₹{order.total.toFixed(0)}</p>
            </div>
            <div>
              <p className="text-[#666] uppercase tracking-widest text-xs">Payment</p>
              <p className="font-semibold text-[#0A192F] mt-1">{order.payment_method.toUpperCase()} • {order.payment_status}</p>
            </div>
            <div>
              <p className="text-[#666] uppercase tracking-widest text-xs">Carrier</p>
              <p className="font-semibold text-[#0A192F] mt-1">Delhivery</p>
            </div>
          </div>
        </div>
      )}

      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/account?tab=orders" className="inline-flex items-center gap-2 bg-[#0A192F] text-white px-6 py-3 rounded-full font-semibold hover:bg-black"><Package className="h-4 w-4" /> Track order</Link>
        <Link to="/shop" className="inline-flex items-center gap-2 border border-[#0A192F] text-[#0A192F] px-6 py-3 rounded-full font-semibold hover:bg-[#0A192F] hover:text-white"><Home className="h-4 w-4" /> Continue shopping</Link>
      </div>
    </div>
  );
}
